import { render, staticRenderFns } from "./ChiefDeptRootView.vue?vue&type=template&id=728c56cf"
import script from "./ChiefDeptRootView.vue?vue&type=script&lang=js"
export * from "./ChiefDeptRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports